var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-box"},_vm._l((_vm.element),function(info,name){return _c('div',{key:name},[_c('ModuleInput',{attrs:{"name":name,"info":info},on:{"changeParameter":_vm.onChangeChild}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }